import { FC, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

import { Box } from '@qwealth/qcore';
import { QNote, QTask } from '@qwealth/qdata';

import { useAppSelector } from 'data/store';
import { selectQNotesbyTaskId } from 'data/selectors/qnotesSelectors';
import QNotePreview from 'components/Households/Common/QNotes/QNotePreview';
import QNoteModal from 'components/Households/Common/QNotes/Modal/QNoteModal';
import { MODAL_MODE_ADD, MODAL_MODE_EDIT, MODAL_MODE_VIEW, ModalModeOptions } from 'data/models/Activity';

interface Props {
  householdId: string;
  qNoteModalMode: ModalModeOptions;
  setQNoteModalMode: React.Dispatch<React.SetStateAction<ModalModeOptions>>;
  setIsTaskModalHidden?: React.Dispatch<React.SetStateAction<boolean>>;
  task: Partial<QTask>;
}

const QNotesSection: FC<Props> = ({ householdId, qNoteModalMode, setQNoteModalMode, setIsTaskModalHidden, task }): JSX.Element => {
  const taskNotes = useAppSelector(selectQNotesbyTaskId(task.id!));
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isQnoteModalOpen, setIsQnoteModalOpen] = useState(false);
  const [note, setNote] = useState<QNote | null>(null);

  const editNote = noteToEdit => {
    setQNoteModalMode(MODAL_MODE_EDIT);
    setNote(noteToEdit);
    setIsQnoteModalOpen(true);
    setIsTaskModalHidden && setIsTaskModalHidden(true);
  };

  const closeQnoteModal = () => {
    setNote(null);
    setIsQnoteModalOpen(false);
    setQNoteModalMode(MODAL_MODE_VIEW);
    setIsTaskModalHidden && setIsTaskModalHidden(false);
  };

  useEffect(() => {
    if (qNoteModalMode === MODAL_MODE_ADD) {
      editNote({ taskId: task.id });
    }
  }, [qNoteModalMode, task.id]);

  return (
    <>
      <Box display="flex" flexDirection="column" gap="default">
        {isEmpty(taskNotes) ? (
          <Box as="span" fontStyle="italic">
            You don't have any note.
          </Box>
        ) : (
          <Box height="100%" overflowY="auto" paddingTop="small">
            {taskNotes.map((qnote: QNote, index) => (
              <QNotePreview key={(qnote?.uuid as string) + index} qnote={qnote} editNote={editNote} setPreviousModalHidden={setIsTaskModalHidden} />
            ))}
          </Box>
        )}
      </Box>
      <QNoteModal
        isOpen={isQnoteModalOpen}
        onClose={closeQnoteModal}
        note={note}
        householdId={householdId}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        isQnoteModalFromTask
        task={task}
      />
    </>
  );
};

export default QNotesSection;
